import { TelemetryErrorEvent } from '../../utilities/insights/models/telemetry-error-event';
import { UploadProgress } from '../../models/ui/upload-progress.model';

export class S3FileUploadError extends TelemetryErrorEvent {
	constructor(error: Error, message: string, uploadProgress: UploadProgress) {
		super({ internalError: error });
		this.name = 's3-file-upload-error';
		this.context.message = message;
		this.context.uploadProgress = uploadProgress;
	}
}
